import type { ReactNode } from 'react';

interface SectionProps {
  title: string;
  right?: ReactNode;
  children: ReactNode;
}

export function Section({ title, right, children }: SectionProps) {
  return (
    <div
      style={{
        background: 'var(--a-card)',
        border: '1px solid var(--a-line)',
        borderRadius: 8,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          padding: '10px 14px',
          borderBottom: '1px solid var(--a-line-soft)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: 'var(--a-ink)',
            letterSpacing: 0.5,
            fontFamily: 'var(--mono)',
            textTransform: 'uppercase',
          }}
        >
          {title}
        </div>
        {right}
      </div>
      {children}
    </div>
  );
}
